import { Fragment } from 'react';

import type { PrivacyNoticeText as PrivacyNoticeTextValue } from '../../../domain/types';

interface PrivacyNoticeTextProps {
  value: PrivacyNoticeTextValue;
}

/**
 * Renders a run of privacy-notice text, turning its declared fragments into links.
 *
 * External links open in a new tab; `mailto:` and the inert cookie-policy placeholder stay in the
 * current one, since neither navigates anywhere a new tab would help.
 *
 * @param {PrivacyNoticeTextProps} props - Component properties
 */
export const PrivacyNoticeText = ({ value }: PrivacyNoticeTextProps) => {
  if (typeof value === 'string') return <>{value}</>;

  return (
    <>
      {value.map((fragment, index) => {
        if (typeof fragment === 'string') return <Fragment key={index}>{fragment}</Fragment>;

        const isExternal = fragment.href.startsWith('http');

        return (
          <a
            className="text-primary underline underline-offset-[3px] transition-colors hover:text-parrot-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
            href={fragment.href}
            key={index}
            {...(isExternal ? { rel: 'noopener noreferrer', target: '_blank' } : {})}
          >
            {fragment.text}
          </a>
        );
      })}
    </>
  );
};
